export interface Event {
  id: string;
  name: string;
  description: string;
  imageUrl: string;
  from: Date;
  to: Date;
  city: string;
  state: string;
  venue: string;
}
